module.exports = __webpack_public_path__ + "img/lvjuyanglao.55f625ca.png";